"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createInstallTask = createInstallTask;
exports.deleteInstallTask = deleteInstallTask;
exports.exportInstallTaskList = exportInstallTaskList;
exports.exportPendingTree = exportPendingTree;
exports.getInstallTaskList = getInstallTaskList;
exports.getInstallTaskLog = getInstallTaskLog;
exports.getInstallTaskNumber = getInstallTaskNumber;
exports.getInstallTaskSigninLog = getInstallTaskSigninLog;
exports.getInstallTaskStatistics = getInstallTaskStatistics;
exports.getPendingTree = getPendingTree;
exports.reserveInstallTask = reserveInstallTask;
exports.updateInstallTask = updateInstallTask;
exports.updateInstallTaskStatus = updateInstallTaskStatus;

var _request = _interopRequireDefault(require("@/utils/request"));

function getInstallTaskList(params) {
  return (0, _request.default)({
    url: 'api/install-task',
    method: 'get',
    params: params
  });
}

function getPendingTree(params) {
  return (0, _request.default)({
    url: 'api/install-task/pending-tree',
    method: 'get',
    params: params
  });
}

function createInstallTask(data) {
  return (0, _request.default)({
    url: 'api/install-task',
    method: 'post',
    data: data
  });
}

function getInstallTaskNumber() {
  return (0, _request.default)({
    url: 'api/install-task/number',
    method: 'get'
  });
}

function updateInstallTask(data) {
  return (0, _request.default)({
    url: 'api/install-task',
    method: 'put',
    data: data
  });
}

function updateInstallTaskStatus(id, params) {
  return (0, _request.default)({
    url: "api/install-task/".concat(id, "/status"),
    method: 'put',
    params: params
  });
}

function deleteInstallTask(id) {
  return (0, _request.default)({
    url: "api/install-task/".concat(id),
    method: 'delete'
  });
}

function getInstallTaskLog(params) {
  return (0, _request.default)({
    url: 'api/install-task-log',
    method: 'get',
    params: params
  });
}

function getInstallTaskSigninLog(params) {
  return (0, _request.default)({
    url: 'api/install-task-signin-log',
    method: 'get',
    params: params
  });
}

function getInstallTaskStatistics() {
  return (0, _request.default)({
    url: 'api/install-task/statistics',
    method: 'get'
  });
}

function reserveInstallTask(data) {
  return (0, _request.default)({
    url: 'api/install-task/reserve',
    method: 'post',
    data: data
  });
}

function exportPendingTree(params) {
  return (0, _request.default)({
    url: 'api/install-task/pending-export',
    method: 'get',
    params: params,
    responseType: 'blob'
  });
}

function exportInstallTaskList(params) {
  return (0, _request.default)({
    url: 'api/install-task/export',
    method: 'get',
    params: params,
    responseType: 'blob'
  });
}